import './header.scss';
import React, { useState } from 'react';
import { Navbar, Nav, NavbarToggler, Collapse } from 'reactstrap';
import LoadingBar from 'react-redux-loading-bar';
import { AccountMenu, ParamsMenu, EcolesMenu, FinanceMenu } from '../menus';
import AnneeScolaireList from '../menus/annee-scolaire';

import { Brand } from './header-components';
import { ROLES } from 'app/config/constants';
import { Badge } from 'antd';
import { useAppSelector } from 'app/config/store';
export interface IHeaderProps {
  isAuthenticated: boolean;
  isAdmin: boolean;
  role: string;
  ribbonEnv: string;
  isInProduction: boolean;
  isOpenAPIEnabled: boolean;
  currentLocale: string;
}

const Header = (props: IHeaderProps) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const toggleMenu = () => setMenuOpen(!menuOpen);
  return (
    <div id="app-header">
      <LoadingBar className="loading-bar" />
      <Navbar data-cy="navbar" dark expand="sm" fixed="top" className="jh-navbar">
        <NavbarToggler aria-label="Menu" onClick={toggleMenu} />
        <Brand />
        <Nav id="header-tabs" className="ml-4" navbar>
          {props.isAuthenticated && (
            <Badge.Ribbon color="#F28E19" style={{ top: -2 }} placement="start" text={<span> {ROLES[props.role[0]]} </span>}></Badge.Ribbon>
          )}
        </Nav>
        <Collapse isOpen={menuOpen} navbar>
          <Nav id="header-tabs" className="ml-5" navbar>
            {props.isAuthenticated && props.isAdmin && <EcolesMenu isAuthenticated={props.isAuthenticated} />}
          </Nav>
          <Nav id="header-tabs" className="ml-auto" navbar>
            {props.isAuthenticated && currentEcole && currentEcole.id && <AnneeScolaireList isAuthenticated={props.isAuthenticated} />}
            {props.isAuthenticated && props.isAdmin && <FinanceMenu isAuthenticated={props.isAuthenticated} />}
            {props.isAuthenticated && props.isAdmin && <ParamsMenu isAuthenticated={props.isAuthenticated} />}
          </Nav>
          <Nav id="header-tabs" className="" navbar>
            {props.isAuthenticated && <AccountMenu isAuthenticated={props.isAuthenticated} />}
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
};

export default Header;
